import * as React from 'react';
import { Skeleton } from '@cian/ui-kit';

import * as styles from './RecommendationDesktopSkeleton.css';

export const RecommendationDesktopSkeleton: React.FC = () => (
  <div className={styles['container']} data-name="RecommendationDesktopSkeleton">
    <Skeleton className={styles['image']} width="100%" height="auto" borderRadius={16} />
    <div className={styles['content']}>
      <Skeleton width="100%" height={52} borderRadius={8} />
      <Skeleton width="100%" height={48} borderRadius={8} />
    </div>
  </div>
);
